import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Button, CircularProgress, Typography, Alert } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { fetchBrand } from '../../api/brands';
import PromptGeneratorPro from '../../components/PromptGenerator/PromptGeneratorPro';

const PromptGeneratorPage = () => {
  const { brandId } = useParams();
  const navigate = useNavigate();

  const [brand, setBrand] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    const loadBrand = async () => {
      try {
        setLoading(true);
        const brandData = await fetchBrand(brandId);
        if (!mounted) return;
        setBrand(brandData);
      } catch (err) {
        console.error('Failed to load brand:', err);
        if (mounted) setError('Unable to load brand details.');
      } finally {
        if (mounted) setLoading(false);
      }
    };

    if (brandId) {
      loadBrand();
    } else {
      setLoading(false);
    }

    return () => {
      mounted = false;
    };
  }, [brandId]);

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)}>
          Back
        </Button>
        <Box>
          <Typography variant="h4" fontWeight={700} gutterBottom>
            Prompt Generator
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Generate creative direction prompts tailored to {brand?.name || 'this brand'}.
          </Typography>
        </Box>
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <PromptGeneratorPro brandId={brandId} />
      )}
    </Box>
  );
};

export default PromptGeneratorPage;
